module.exports = __webpack_public_path__ + "img/image2.b2dd7ea5.png";